import http from "../http-common"


class DataService {

  
  

  //To get alerts for specific client
  // getAlertsForClient(clientid){
  //   return http.get("/zabbix/alerts/"+clientid);
  // }
 
async  getPromotion(){
  return await http.get("/frontend/promotion?bId=1");
}

 async postActionOnSubmit(data){
    console.log("I am here post submit")
    console.log(data)
    return  await http.post("/createpass",data);
  }

  async getLogoImage(promoid)
  {
    return await http.get("/createpass/promoimage/"+promoid);
  }
  
}

export default new DataService();